import { render, staticRenderFns } from "./LeaderBoardNormal.vue?vue&type=template&id=4bb4fb12&scoped=true"
import script from "./LeaderBoardNormal.vue?vue&type=script&lang=js"
export * from "./LeaderBoardNormal.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardNormal.vue?vue&type=style&index=0&id=4bb4fb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4fb12",
  null
  
)

export default component.exports